var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87143 5.99994C5.87143 6.54501 6.08796 7.06774 6.47338 7.45316C6.85879 7.83858 7.38153 8.05511 7.9266 8.05511C8.47166 8.05511 8.9944 7.83858 9.37982 7.45316C9.76524 7.06774 9.98176 6.54501 9.98176 5.99994C9.98176 5.45488 9.76524 4.93214 9.37982 4.54672C8.9944 4.1613 8.47166 3.94478 7.9266 3.94478C7.38153 3.94478 6.85879 4.1613 6.47338 4.54672C6.08796 4.93214 5.87143 5.45488 5.87143 5.99994ZM15.894 5.52652C14.1545 1.86209 11.525 0.0179443 8 0.0179443C4.47319 0.0179443 1.84551 1.86209 0.105961 5.52835C0.0361868 5.6761 0 5.83747 0 6.00086C0 6.16425 0.0361868 6.32562 0.105961 6.47336C1.84551 10.1378 4.47502 11.9819 8 11.9819C11.5268 11.9819 14.1545 10.1378 15.894 6.47153C16.0353 6.17426 16.0353 5.82929 15.894 5.52652ZM7.9266 9.22949C6.14301 9.22949 4.69705 7.78353 4.69705 5.99994C4.69705 4.21635 6.14301 2.7704 7.9266 2.7704C9.71019 2.7704 11.1561 4.21635 11.1561 5.99994C11.1561 7.78353 9.71019 9.22949 7.9266 9.22949Z",
    fill: "#3C4554"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.cf6f54edd271640528eecb293696a69a.svg";
export { ForwardRef as ReactComponent };